'use client';

import { useMemo, type FC } from 'react';
import { Heading, Spacer, Flex, Icon, Text, Separator } from '@/_components';
import styles from './InlineCommentList.module.css';
import type { InlineCommentListProps } from './InlineCommentList.types';
import type { QuestionNote } from '@/_types/models/questionnaire';

export const InlineCommentList: FC<InlineCommentListProps> = ({ question }) => {
  const comments: Array<QuestionNote> = useMemo(
    () =>
      question?.filtered_questionnaire_comments?.filter(
        (note) => !note?.removed && !note?.deleted_at,
      ),
    [question],
  );

  if (!comments?.length) return null;

  return (
    <div className={styles.inlineCommentList}>
      <Separator />
      <Flex
        isColumn={true}
        className={styles.inlineCommentList__Container}
        gap={2}
      >
        <Heading level={6}>Comments</Heading>
        <Spacer gap={4} />
        {comments?.map((comment: QuestionNote, key) => {
          return (
            <Flex
              key={key}
              isYCentered={true}
              gap={2}
              padding={1}
              className={styles.inlineCommentListItem}
            >
              <Icon name="note" size={16} />
              <Text type="small">{comment.text!}</Text>
            </Flex>
          );
        })}
      </Flex>
      <Separator />
      <Spacer gap={4} />
    </div>
  );
};
